import { sessionStorageKeeperService } from '@/shared/auth-service';
import axios from 'axios';

const urlPostfix = '/api';
// These APIs return Promise objects.

class CcReportingApi {
  async generalReportAsPdf(baseurl: string, paramsData: any) {
    return await axios.get(`${baseurl}${urlPostfix}/report`, {
      headers: {
        authorization: sessionStorageKeeperService.retrieve('ccToken'),
      },
      params: paramsData,
      responseType: 'blob',
    });
  }

  async generateCCScheduleReport(baseurl: string, paramsData: any) {
    const options = {
      headers: {
        authorization: sessionStorageKeeperService.retrieve('ccToken'),
      },
    };
    return axios.post<any>(
      `${baseurl}${urlPostfix}/report`,
      { ...paramsData },
      options,
    );
  }

  deleteSchedule(baseurl:string, scheduleId: any) {
    const options = {
      headers: {
        authorization: sessionStorageKeeperService.retrieve('ccToken'),
      },
    };
    return axios.post<any>(
      `${baseurl}${urlPostfix}/report/scheduledReport/delete`,
      { scheduleId },
      options,
    );
  }

  async download(baseurl:string, id: any) {
    if (!this.doesFileExist(`${baseurl}${urlPostfix}/report/id/${id}`)) {
      return new Promise(resolve => resolve({ status: 404, message: 'record not exists.' }));
    }
    return await axios.get(`${baseurl}${urlPostfix}/report/id/${id}`, {
      headers: {
        authorization: sessionStorageKeeperService.retrieve('ccToken'),
      },
      responseType: 'blob',
    });
  }

  doesFileExist(urlToFile: string) {
    let isfileExists: boolean = true;
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    xhr.setRequestHeader('authorization', sessionStorageKeeperService.retrieve('ccToken'));
    try {
      xhr.send();
      /** checking fo the chrome browser **/
      if (xhr.status === 400) {
        isfileExists = false;
      }
    } catch (e) {
      /** checking fo the firefox browser **/
      if (xhr.status === 0 || xhr.status === 400) {
        isfileExists = false;
      }
    }
    return isfileExists;
  }

}

export const ccReportingApi = new CcReportingApi();
